import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getRecord({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.get-record'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async create({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.create'), payload)
    if (apiResult && apiResult.data) {
      return apiResult
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult
    }
  },
  async delete({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getDefaultValues({ commit }, payload) {
    const apiResult = await apiService.post(route('member.trunk-volume-parameter.get-default-values'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}